<template>
  <div v-if="User.info">
    <div
      :class="{ hidden: !changeTAPassword.modalActive }"
      class="fixed flex justify-center items-center inset-0 z-50 bg-gray-900 bg-opacity-70 w-full h-full"
      id="changeTAPassword"
    >
      <div class="bg-white rounded-xl py-10 px-8 w-10/12 lg:w-[550px] max-w-[550px] m-auto relative">
        <button @click="closeChangePasswordModal()" class="bg-white rounded-full h-10 w-10 absolute -top-14 ltr:right-0 rtl:left-0 appearance-none p-0">
          <div class="h-6 w-0.5 bg-blue rotate-45 ltr:ml-5 rtl:mr-5"></div>
          <div class="h-6 w-0.5 bg-blue -rotate-45 -mt-6 ltr:ml-5 rtl:mr-5"></div>
        </button>
        <p class="font-display text-2xl font-bold text-gray-900 pb-9">{{ $t('change_password_of').tTitle() }} {{ changeTAPassword.TAID }}</p>
        <form @submit.prevent data-vv-scope="form-changePassword" :class="{ 'direction-rtl': Language == 'fa' }">
          <div class="mb-3">
            <label for="newPassword" class="text-base text-gray-900">{{ $t('new_password').tTitle() }}</label>
            <div class="relative">
              <input
                type="text"
                name="newPassword"
                v-validate="{ required: true, 'strong-password': changeTAPassword.new }"
                :class="{'ring-1 ring-orange bg-gray-100': errors.has('form-changePassword.newPassword')}"
                class="rounded-md bg-gray-100 ltr:pl-5 rtl:pr-5 w-full h-11 mt-2 text-base text-gray-900 border placeholder:text-gray-900"
                :data-vv-as="$t('new_password').tTitle()"
                :placeholder="$t('new_password').tTitle()"
                @input="$event => passwordChanged($event, 'new')"
                :value="showNewPwd ? changeTAPassword.new : passwordValueMask('new')"
                @paste.prevent
                @blur="validateField('form-changePassword.newPassword', 'new')"
              />
              <button class="absolute ltr:right-6 rtl:left-6 bottom-4 focus:border-none focus:outline-none" @click="showNewPwd = !showNewPwd">
                <img src="../assets/img/settings-eye-hidden.svg" width="20" alt="show password" v-if="!showNewPwd" />
                <img src="../assets/img/settings-eye-shown.svg" width="20" alt="hide password" v-if="showNewPwd" />
              </button>
            </div>

            <span v-show="errors.has('form-changePassword.newPassword')" class="text-xs leading-3 text-red rtl:text-right">{{
              errors.first('form-changePassword.newPassword')
            }}</span>
          </div>

          <div>
            <label for="newPasswordConfirm" class="text-base text-gray-900">{{ $t('confirm_new_password').tTitle() }}</label>
            <div class="relative">
              <input
                v-validate="{ required: true, 'custom-confirmed-new': [changeTAPassword.new, changeTAPassword.newConfirm] }"
                type="text"
                name="newPasswordConfirm"
                :class="{'ring-1 ring-orange' : errors.has('form-changePassword.newPasswordConfirm')}"
                class="rounded-md bg-gray-100 ltr:pl-5 rtl:pr-5 w-full h-11 mt-2 text-base text-gray-900 placeholder:text-gray-900"
                :data-vv-as="$t('confirm_new_password').tTitle()"
                :placeholder="$t('confirm_new_password').tTitle()"
                ref="newPasswordConfirm"
                @input="$event => passwordChanged($event, 'newConfirm')"
                :value="showConNewPwd ? changeTAPassword.newConfirm : passwordValueMask('newConfirm')"
                @paste.prevent
                @blur="validateField('form-changePassword.newPasswordConfirm', 'newConfirm'), validateField('form-changePassword.newPassword', 'new')"
              />
              <button class="absolute ltr:right-6 rtl:left-6 bottom-4 focus:border-none focus:outline-none" @click="showConNewPwd = !showConNewPwd">
                <img src="../assets/img/settings-eye-hidden.svg" width="20" alt="show password" v-if="!showConNewPwd" />
                <img src="../assets/img/settings-eye-shown.svg" width="20" alt="hide password" v-if="showConNewPwd" />
              </button>
            </div>

            <span v-show="errors.has('form-changePassword.newPasswordConfirm')" class="text-xs text-red rtl:text-right">{{
              errors.first('form-changePassword.newPasswordConfirm')
            }}</span>
          </div>

          <div class="mt-9 flex gap-5">
            <Button @click="changeTAPasswordReq()" customClasses="w-48">
              {{ $t('change_password').tTitle() }}
            </Button>
            <Button mode="white" @click="closeChangePasswordModal()" customClasses="w-auto !font-normal">
              {{ $t('cancel').tTitle() }}
            </Button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { service } from '../main.js'
import { mapActions, mapGetters } from 'vuex'
import Button from './reusableComponents/Button.vue'

export default {
  props: ['TAPasswordData'],
  components: { Button },
  data() {
    return {
      changeTAPassword: this.TAPasswordData,
      showNewPwd: false,
      showConNewPwd: false,
    }
  },
  watch: {
    // watcher for the i18n language change
    '$i18n.locale'() {
      this.$validator.reset()
    },
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Language: 'language/code',
      logoLoaderActive: 'logoLoader/active',
    }),
    passwordValueMask() {
      return type => {
        let password = this.changeTAPassword[type]
        let string = '*'.repeat(password.length)
        return string
      }
    },
  },
  mounted() {},
  methods: {
    changeTAPasswordReq() {
      // validate
      // this['logoLoader/set'](true)
      this.$validator
        .validateAll('form-changePassword')
        .then(result => {
          if (!result) {
            // this['logoLoader/set'](false)
          } else {
            service
              .post('/ta/change-password', {
                TAID: this.changeTAPassword.TAID,
                userID: this.User.info.ID,
                password: this.changeTAPassword.new,
                passwordConfirm: this.changeTAPassword.newConfirm,
              })
              .then(() => {
                this.closeChangePasswordModal()
                // this['logoLoader/set'](false)

                this.$toasted.success(this.$t('success'))
              })
              .catch(error => {
                this.closeChangePasswordModal()
                // this['logoLoader/set'](false)

                if (typeof error.response.data !== 'undefined') {
                  this.$toasted.error(this.$t(error.response.data.meta.messageID) + '<span class="error-id">' + error.response.data.id + '</span>')
                }
              })
          }
        })
        .catch(() => {
          // this['logoLoader/set'](false)
        })
    },
    closeChangePasswordModal() {
      this.changeTAPassword.modalActive = false
      this.changeTAPassword.TAID = null
      this.changeTAPassword.new = ''
      this.changeTAPassword.newConfirm = ''
      this.errors.clear()
      this.$nextTick(() => {
        this.$validator.reset()
      })
    },
    ...mapActions(['logoLoader/set']),
    passwordChanged(pass, type) {
      if (type === 'newPasswordConfirm') this.validateField('newPassword', 'new')
      const passLength = pass.target.value.length
      const newCharacter = pass.data
      const cursorPosition = pass.target.selectionStart
      const password = this.changeTAPassword[type]
      const changeCount = password.length + 1 - passLength

      if (newCharacter === null) {
        // delete from a cursor position in the password
        if (cursorPosition >= 0) {
          this.changeTAPassword[type] = password.substring(0, cursorPosition) + password.substring(cursorPosition + 1)
        }
        // delete the whole password
        if (password.length === 1 || passLength === 0) {
          this.changeTAPassword[type] = ''
        }
        // delete selection from the password
        if (changeCount > 2) {
          this.changeTAPassword[type] = password.substring(0, cursorPosition) + password.substring(cursorPosition + changeCount - 1)
        }
      } else {
        if (password.length - pass.target.value.length < -3) {
          this.changeTAPassword[type] = ''
        } else {
          if (cursorPosition === password.length + 1) {
            // add new char in the end of the password
            this.changeTAPassword[type] += newCharacter
          } else if (changeCount === 0) {
            // add new char in the position of the cursor
            this.changeTAPassword[type] = this.changeTAPassword[type].substring(0, cursorPosition - 1) + newCharacter + this.changeTAPassword[type].substring(cursorPosition - 1)
          } else {
            // replace multiple chars in the password
            this.changeTAPassword[type] = password.substring(0, cursorPosition - 1) + newCharacter + password.substring(changeCount + 1)
          }
          if (this.changeTAPassword[type].length !== passLength) {
            this.changeTAPassword[type] = this.changeTAPassword[type].substring(0, passLength)
          }
        }
      }
    },
    async validateField(field, type) {
      return await this.$validator.validate(field, this.changeTAPassword[type])
    },
  },
}
</script>
